// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1cuqK","name":"Header_name__3Tz0n","birthday":"Header_birthday__2Jlmj","skeleton":"Header_skeleton__255VV"};